import { useNavigate } from "react-router-dom";
import OptimizedImage from "./OptimizedImage";

function ProjectCard({ label, img, slug, type, onClick, isActive }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    // Pour desktop : carte active est uniquement cliquable (pas de swipe)
    if (isActive && window.innerWidth > 768) {
      // Navigation directe vers la page du projet
      e.stopPropagation();
      navigate(`/realisation/${slug}`);
      return;
    }

    // Comportement pour mobile ou cartes non-actives
    e.stopPropagation();

    // Si la carte n'est pas active, la centrer
    if (onClick && !isActive) {
      e.preventDefault();
      onClick(e);
      return;
    }

    // Si la carte est active sur mobile, naviguer normalement
    navigate(`/realisation/${slug}`);
  };

  return (
    <div
      className={`project-card ${isActive ? 'is-active' : ''}`}
      onClick={handleClick}
      style={{
        userSelect: 'none'
      }}
    >
      <div className="image-container">
        <OptimizedImage
          src={img}
          alt={`${label} - ${type} par Tanguy Perroit`}
          sizes="(max-width: 768px) 100vw, 50vw"
          loading={isActive ? "eager" : "lazy"}
          style={{ userSelect: 'none', pointerEvents: 'none' }}
        />
        <div className="category-tag">{type}</div>

        <div className="overlay">
          <h3 className="project-title">{label}</h3>
          <div className="view-project">
            <span>Voir la série</span>
            <span className="arrow">→</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectCard;